// extracted by mini-css-extract-plugin
export default {"link":"style_link__UBgW-","centerGrid":"style_centerGrid__deCkM","img":"style_img__akHmQ","namegame":"style_namegame__zvh8Y","center":"style_center__e-S7A"};